import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ActiveGraphService {


  public graph;
  public miniGraph;

  constructor() { }

  destroyGraphs(){
    
    if(this.graph){
      this.graph.destroy();
      this.graph = null;
    }
    if(this.miniGraph){
      this.miniGraph.destroy();
      this.miniGraph = null;
    }
  }

}
